import React from 'react';
import InputError from '../InputError';
import './FormInput.scss';

export default function Input({ onChange, label, info, containerStyle, className, error, isnumeric, allowspaces, isphone, disabled, placeholder, ...rest })
{
    const handleInput = (e)=>{
        if( isnumeric )
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
        
        if( allowspaces === false )
            e.target.value = e.target.value.replace(/ /g, '');

        if( isphone )
            e.target.value = e.target.value.replace(/\+/g, '');

        return onChange(e);
    }

    return (
        <div className={"form-input" + (rest.required ? ' required ' : '')}>
            { label ? <label>{label}</label> : null }
            <input 
                {...rest}
                disabled={disabled}
                placeholder={placeholder}
                title={placeholder || label || info || ''} 
                className={(error ? ' error ' : '') + (className || '')} 
                onChange={handleInput}
            />
            { error ? <InputError error={error}/> : null }
        </div>
    ) 
}